// All views go through lazyWithRetry: a post-deploy stale-chunk failure
// triggers a one-time full reload (fresh index.html + new chunk hashes)
// instead of dead-ending at the section error boundary.
import { lazyWithRetry as lazy } from '@/lib/lazyWithRetry'

// Project views - Switch to ProjectsListRedesign to test new layout
export const ProjectsList = lazy(() =>
  import('./project/ProjectsListRedesign').then(m => ({ default: m.ProjectsListRedesign }))
)
export const ProjectView = lazy(() =>
  import('./project/ProjectViewRedesign').then(m => ({ default: m.ProjectViewRedesign }))
)

// Routine views — the Routines picture (the household's week)
export const RoutinesList = lazy(() =>
  import('./routine/RoutinesPicture').then(m => ({ default: m.RoutinesPicture }))
)
export const RoutineForm = lazy(() =>
  import('./routine/RoutineForm').then(m => ({ default: m.RoutineForm }))
)
export const RoutineInput = lazy(() =>
  import('./routine/RoutineInput').then(m => ({ default: m.RoutineInput }))
)

// Task view (desktop) - Switch to TaskViewRedesign to test new layout
export const TaskView = lazy(() =>
  import('./task/TaskViewRedesign').then(m => ({ default: m.TaskViewRedesign }))
)

// Contact view (desktop)
export const ContactView = lazy(() =>
  import('./contact/ContactViewRedesign').then(m => ({ default: m.ContactViewRedesign }))
)
export const ContactsList = lazy(() =>
  import('./contact/ContactsList').then(m => ({ default: m.ContactsList }))
)

// Recipe viewer
export const RecipeViewer = lazy(() =>
  import('./recipe/RecipeViewer').then(m => ({ default: m.RecipeViewer }))
)

// Auth (only for logged-out state)
export const AuthForm = lazy(() =>
  import('./AuthForm').then(m => ({ default: m.AuthForm }))
)

// Calendar connect banner
export const CalendarConnect = lazy(() =>
  import('./CalendarConnect').then(m => ({ default: m.CalendarConnect }))
)

// Goals views
export const GoalsList = lazy(() =>
  import('./goals/GoalsList').then(m => ({ default: m.GoalsList }))
)
export const GoalView = lazy(() =>
  import('./goals/GoalView').then(m => ({ default: m.GoalView }))
)

// Settings
export const SettingsPage = lazy(() =>
  import('./settings/SettingsPage').then(m => ({ default: m.SettingsPage }))
)

export const FocusMode = lazy(() =>
  import('./focus/FocusMode').then(m => ({ default: m.FocusMode }))
)
// Guided sessions (Five Horizons) were deleted in the 2026-09-01 pare-down —
// the wizard era stays dead (docs/vision-streamlined.md); paper owns thinking.

// Detail panel (only renders when an item is selected)
export const DetailPanelRedesign = lazy(() =>
  import('./detail/DetailPanelRedesign').then(m => ({ default: m.DetailPanelRedesign }))
)

// Lists views
export const ListsList = lazy(() =>
  import('./list/ListsList').then(m => ({ default: m.ListsList }))
)
export const ListView = lazy(() =>
  import('./list/ListView').then(m => ({ default: m.ListView }))
)

// History
export const CompletedTasksView = lazy(() =>
  import('./history/CompletedTasksView').then(m => ({ default: m.CompletedTasksView }))
)
